import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BACKEND_URL } from "../Config/Config";

const getUserDetails = () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  return JSON.parse(userDetails);
};

const findTestCasesByPriority = async ({ priority }) => {
  const user = getUserDetails();
  const response = await axios.get(
    `${API_BACKEND_URL}/testcase/findByPriority?companyId=${user.companyid}&priority=${priority}`,
  );
  return response.data;
};

export const useFindTestCasesByPriority = (options = {}, priority) => {
  return useQuery({
    queryKey: ["priorityTcs", priority],
    queryFn: () => findTestCasesByPriority({ priority }),
    ...options,
  });
};

const findTestCasesByType = async ({ testType }) => {
  const user = getUserDetails();
  const response = await axios.get(
    `${API_BACKEND_URL}/testcase/findByTCType?companyId=${user.companyid}&testType=${testType}`,
  );
  return response.data;
};

export const useFindTestCasesByType = (options = {}, testType) => {
  return useQuery({
    queryKey: ["testTypeTc", testType],
    queryFn: () => findTestCasesByType({ testType }),
    ...options,
  });
};

const findTestCasesByCollection = async ({ name }) => {
  const user = getUserDetails();
  const response = await axios.get(
    `${API_BACKEND_URL}/testcase/findByCollection?companyId=${user.companyid}&name=${name}`,
  );
  return response.data;
};

export const useFindTestCasesByCollection = (options = {}, name) => {
  return useQuery({
    queryKey: ["collectionTc", name],
    queryFn: () => findTestCasesByCollection({ name }),
    ...options,
  });
};
